// Mock data for S2U Enterprises website

export const companyInfo = {
  name: "S2U ENTERPRISES",
  tagline: "Building Excellence in Medical Infrastructure",
  phone: "95600 43484",
  fax: "011 7152 2655",
  email: "s2uenterprises@gmail.com",
  address: "Plot No: 66, Upper Ground Floor, A-Block, Bhagwati Garden, Uttam Nagar, New Delhi-110059",
  gstin: "07BJOPR0219Q1ZK",
  responseTime: "3 hours in Delhi & NCR",
  availability: "24x7 Service"
};

export const services = [
  {
    id: 1,
    title: "Diagnostic / Examine Room",
    icon: "Hospital",
    description: "Specialized infrastructure solutions for medical facilities including MRI rooms, CT scan rooms, and CathLabs with turnkey project management.",
    features: ["MRI Room Setup & MRI Machine Installation", "CT Scan Room Setup & Machine Installation", "CathLab Projects & Machine Installation", "PET CT Room Setup & Machine Installation","Turnkey Solutions"],
    image: "https://images.unsplash.com/photo-1717096945404-e6f12be85849"
  },
  {
    id: 2,
    title: "Electrical Services",
    icon: "Zap",
    description: "Comprehensive electrical solutions for industrial and commercial spaces with a focus on safety and reliability.",
    features: ["Industrial Electrical", "Commercial Installations", "Power Distribution", "Maintenance Services"],
    image: "https://images.unsplash.com/photo-1769442263053-a60acf73f00a"
  },
  {
    id: 3,
    title: "HVAC Systems",
    icon: "Wind",
    description: "Advanced air-conditioning solutions for domestic and industrial applications ensuring optimal climate control.",
    features: ["Industrial HVAC", "Domestic AC Systems", "Ventilation Solutions"],
    image: "https://images.unsplash.com/photo-1667983453881-4992fe86ab1b"
  },
  {
    id: 4,
    title: "Turnkey Projects",
    icon: "Building2",
    description: "End-to-end project management from planning to execution, ensuring timely delivery and quality standards.",
    features: ["Project Planning", "Execution Management", "Quality Assurance", "Timely Delivery"],
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5"
  },
  {
    id: 5,
    title: "Interior Design",
    icon: "Paintbrush",
    description: "Professional interior design and execution services tailored for medical and commercial facilities.",
    features: ["Space Planning", "Diagnostic Room Interiors", "Commercial Design", "Complete Execution"],
    image: "https://images.unsplash.com/photo-1535732759880-bbd5c7265e3f"
  },
  {
    id: 6,
    title: "Civil Works",
    icon: "HardHat",
    description: "Comprehensive civil construction services ensuring structural integrity and compliance with standards.",
    features: ["Construction", "Renovation", "Structural Work", "Compliance Standards"],
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5"
  }
];

export const projects = [
  {
    id: 1,
    title: "AIIMS Delhi - CT Room & CathLab",
    client: "AIIMS Delhi",
    category: "Medical Service ",
    description: "Complete turnkey project for CT Room and CathLab installation with advanced infrastructure setup.",
    image: "https://images.pexels.com/photos/7088490/pexels-photo-7088490.jpeg",
    year: "2019",
    scope: ["CT Room Turnkey", "CathLab Installation", "Electrical Setup", "HVAC Integration"]
  },
  {
    id: 2,
    title: "AIIMS Bikaner - Turnkey Work",
    client: "AIIMS Bikaner",
    category: "Turnkey Projects",
    description: "Comprehensive turnkey project including infrastructure, electrical, and HVAC systems.",
    image: "https://images.pexels.com/photos/13176358/pexels-photo-13176358.jpeg",
    year: "2024",
    scope: ["Complete Infrastructure", "Electrical Systems", "HVAC Installation", "Project Management"]
  },
  {
    id: 3,
    title: "Numed Super Specialty Hospital",
    client: "Numed Hospital",
    category: "Medical Service",
    description: "MRI Room interior work with specialized shielding and infrastructure requirements.",
    image: "/images/Numed3.jpg.jpeg",
    year: "2025",
    scope: ["MRI Room Interior", "RF Shielding", "HVAC Setup", "Electrical Infrastructure"]
  },
  {
    id: 4,
    title: "UCDC Guwahati - MRI & CT Room",
    client: "UCDC Guwahati",
    category: "Medical Service",
    description: "Complete interior work for MRI and CT scan rooms with turnkey solutions.",
    image: "/images/UCDC.jpg.jpeg",
    year: "Live",
    scope: ["MRI Interior", "CT Room Setup", "Infrastructure Work", "Equipment Installation"]
  },
  {
    id: 5,
    title: "Neo Hospital Noida",
    client: "Neo Hospital",
    category: "Medical Service",
    description: "CT Room interior work with advanced climate control and electrical systems.",
    image: "https://images.pexels.com/photos/13176358/pexels-photo-13176358.jpeg",
    year: "2025",
    scope: ["CT Room Interior", "Climate Control", "Electrical Work", "Quality Finishing"]
  },
  {
    id: 6,
    title: "Krsnaa Diagnostic",
    client: "Krsnaa Diagnostic",
    category: "Interior Project",
    description: "Complete turnkey project for medical facility upgrades and infrastructure enhancement.",
    image: "/images/Krsnaa.jpg.jpeg",
    year: "Live",
    scope: ["Infrastructure Upgrade", "Electrical Systems", "HVAC Installation", "Project Completion"]
  },
  {
    id: 6,
    title: "Karkinos",
    client: "Karkinos",
    category: "Interior Project",
    description: "Complete turnkey project for medical facility upgrades and infrastructure enhancement.",
    image: "/images/Karkinos.jpg.jpeg",
    year: "2026",
    scope: ["Infrastructure Upgrade", "Electrical Systems", "HVAC Installation", "Project Completion"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Dr. Rajesh Kumar",
    designation: "Director, Medical Services",
    company: "AIIMS Delhi",
    content: "S2U Enterprises delivered exceptional quality in our CT Room and CathLab project. Their technical expertise and timely execution were remarkable.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216"
  },
  {
    id: 2,
    name: "Mr. Anil Sharma",
    designation: "Project Manager",
    company: "Numed Super Specialty Hospital",
    content: "Outstanding work on our MRI room infrastructure. The team's attention to detail and commitment to quality standards exceeded our expectations.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a"
  },
  {
    id: 3,
    name: "Dr. Priya Verma",
    designation: "Hospital Administrator",
    company: "Neo Hospital Noida",
    content: "Professional, reliable, and technically sound. S2U Enterprises completed our CT room interior work with precision and efficiency.",
    rating: 5,
    image: "https://images.pexels.com/photos/1181396/pexels-photo-1181396.jpeg"
  }
];

export const stats = [
  { label: "Years Experience", value: "10+", icon: "Award" },
  { label: "Projects Completed", value: "150+", icon: "CheckCircle" },
  { label: "Happy Clients", value: "100+", icon: "Users" },
  { label: "Response Time", value: "3 hrs", icon: "Clock" }
];

export const whyChooseUs = [
  {
    title: "Expert Team",
    description: "Experienced professionals with extensive expertise in Mechanical Installation Services / technical services.",
    icon: "Users"
  },
  {
    title: "Quality Standards",
    description: "Commitment to maintaining the highest quality standards at each step of our business process.",
    icon: "Award"
  },
  {
    title: "24x7 Support",
    description: "Round-the-clock service availability with response time of not more than 3 hours in Delhi & NCR.",
    icon: "HeadphonesIcon"
  },
  {
    title: "Ethical Practices",
    description: "Operating on principles of integrity, transparency, and fair dealing in all our business relationships.",
    icon: "Shield"
  },
  {
    title: "Turnkey Solutions",
    description: "Complete end-to-end project management from planning to execution and after-sales support.",
    icon: "Package"
  },
  {
    title: "Long-term Relationships",
    description: "Building lasting partnerships by consistently meeting and exceeding customer expectations.",
    icon: "Handshake"
  }
];

export const teamMembers = [
  {
    name: "Rajesh Patel",
    designation: "Managing Director",
    image: "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a"
  },
  {
    name: "Anita Sharma",
    designation: "Project Manager",
    image: "https://images.pexels.com/photos/1181396/pexels-photo-1181396.jpeg"
  },
  {
    name: "Vikram Singh",
    designation: "Technical Head",
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216"
  }
];

export const aboutContent = {
  mission: "To work towards building long-term relationships by meeting customer expectations one after one, delivering excellence in medical infrastructure and technical services.",
  vision: "To be the leading provider of medical infrastructure and technical solutions, recognized for quality, reliability, and customer satisfaction.",
  philosophy: "We believe an exceptional experience begins with strong relationships formed by listening to our customer's needs and sharing expertise to deliver optimal solutions.",
  values: [
    "Customer Satisfaction",
    "Quality Excellence",
    "Ethical Practices",
    "Innovation",
    "Reliability",
    "Transparency"
  ]
};
